import React from "react";
import HubPlaceholderContainer from "containers/AllInOneDashboard/HubPlaceholderContainer";
import HubPlaceholderStore from "containers/AllInOneDashboard/HubPlaceholderStore";

const ConnectedHubPlaceholder = HubPlaceholderStore(HubPlaceholderContainer);

const HoldingsHub = () => (
  <ConnectedHubPlaceholder
    title="Holdings"
    message="Your unified holdings view is coming soon. Check back here for a consolidated view across all your products."
  />
);

export default HoldingsHub;
